import { ComponentType, SVGProps } from 'react';
import {
  DocumentIcon,
  DocumentTextIcon,
  PresentationChartBarIcon,
} from '@heroicons/react/24/outline';

import { bookType, MaterialType } from '@/models/Book';

export type MaterialTypeOption = {
  type: MaterialType;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  bookTypes: bookType[];
  comingSoon: boolean;
};

const MATERIAL_TYPE_OPTIONS: MaterialTypeOption[] = [
  {
    type: MaterialType.TEXT,
    Icon: DocumentTextIcon,
    bookTypes: ['STUDENT', 'TEACHER'],
    comingSoon: true,
  },
  {
    type: MaterialType.SLIDE,
    Icon: PresentationChartBarIcon,
    bookTypes: ['STUDENT'],
    comingSoon: true,
  },
  {
    type: MaterialType.PDF_INTERACTIVE,
    Icon: DocumentIcon,
    bookTypes: ['STUDENT', 'TEACHER'],
    comingSoon: true,
  },
];

export const getMaterialTypeOptions = (bookType: bookType) =>
  MATERIAL_TYPE_OPTIONS.filter(option => option.bookTypes.includes(bookType));
